import { createContext } from 'react';

import { InnerBordersMode, SizeProps } from './type';

export const CellSizeContext = createContext<SizeProps['cellSize']>(undefined);

export const ColumnsWidthContext = createContext<string[]>([]);

export const InnerBordersContext = createContext<InnerBordersMode>('all');
